import Vue from 'vue'
import Vuex, { StoreOptions, GetterTree, MutationTree, ActionTree } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import RootState from './RootState'
import { user } from './modules/user'
import { report } from './modules/report'

Vue.use(Vuex)

const rootGetters: GetterTree<RootState, {}> = {
  token(state): string {
    return state.token
  },
  access(state): boolean {
    return state.access
  }
}

enum MutationType {
  SetToken = 'setToken',
  ResetState = 'resetState',
  SetAccess = 'setAccess'
}

const rootMutations: MutationTree<RootState> = {
  [MutationType.SetToken]: (state, payload) => {
    state.token = payload
  },
  [MutationType.ResetState]: (state) => {
    state.token = null
  },
  [MutationType.SetAccess]: (state, payload) => {
    state.access = payload
  }
}

const rootActions: ActionTree<RootState, RootState> = {
  resetState({ commit }) {
    commit(MutationType.ResetState)
    localStorage.removeItem('weproov')
  },
  updateAccess({ commit }, payload) {
    commit(MutationType.SetAccess, payload)
  },
  updateToken({ commit }, payload) {
    commit(MutationType.SetToken, payload)
  }
}

const storeOptions: StoreOptions<RootState> = {
  state: {
    token: null,
    access: false
  },
  getters: rootGetters,
  mutations: rootMutations,
  actions: rootActions,
  modules: {
    user,
    report
  },
  plugins: [
    createPersistedState({
      key: 'weproov'
    })
  ]
}

export { MutationType }
export default new Vuex.Store(storeOptions)
